import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/logo.png';
import '../../../assets/css/grid.scss';
import '../../../assets/css/style.scss';
import * as authApis from 'apis/auth';
import * as couponApis from 'apis/coupons';

function PartnerVerifyPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');
    if (!token || role !== 'partner') {
      navigate('/partner/verify/login');
    }
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await authApis.logout();
    } catch (e) {
      // ignore
    }
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/partner/verify/login');
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setResult(null);
    try {
      const response = await couponApis.verifyCoupon(code.trim().toUpperCase());
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Verification failed');
    }
  };

  const handleRedeem = async () => {
    setError('');
    setMessage('');
    try {
      const response = await couponApis.redeemCoupon(code.trim().toUpperCase());
      setResult(response.data);
      setMessage('Coupon marked as redeemed');
    } catch (err) {
      setError(err.response?.data?.message || 'Redeem failed');
    }
  };

  return (
    <div className="App">
      <div className="col-lg-100 col-md-100 col-sm-100 full-height pt-40">
        <div className="login pt-40" style={{ maxWidth: 480 }}>
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="login-title">
            <h1>Verify coupon</h1>
            <h6>Enter the member code</h6>
          </div>

          <form className="login-form" onSubmit={handleVerify}>
            <div className="login-input">
              <label htmlFor="code">Coupon code</label>
              <input
                type="text"
                name="code"
                placeholder="e.g. MXG250AB"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                required
                maxLength={8}
              />
            </div>
            {error && <div className="text-bright-red mb-100">{error}</div>}
            {message && <div className="text-green mb-100">{message}</div>}
            <div className="login-input">
              <button type="submit">VERIFY</button>
            </div>
          </form>

          {result && (
            <div className="ff-inter mt-200" style={{ textAlign: 'left' }}>
              <h3
                className={`ff-inter-semibold mb-100 ${
                  result.canRedeem ? 'text-green' : 'text-bright-red'
                }`}
              >
                {result.heading || (result.canRedeem ? 'Coupon Valid' : 'Coupon Invalid')}
              </h3>
              {result.message && (
                <p className={`mb-100 ${result.canRedeem ? 'text-green' : 'text-bright-red'}`}>
                  {result.message}
                </p>
              )}
              <p className="text-white"><strong>Member:</strong> {result.member?.name}</p>
              <p className="text-white"><strong>Tier:</strong> {result.tier || '-'}</p>
              <p className="text-white"><strong>Offer:</strong> {result.offer?.summary}</p>
              <p className="text-white"><strong>Status:</strong> {result.status}</p>
              {result.expiresAt && (
                <p className="text-white">
                  <strong>Expires:</strong>{' '}
                  {new Date(result.expiresAt).toLocaleDateString(undefined, {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric',
                  })}
                </p>
              )}
              {result.redemptionCount > 0 && (
                <p className="text-white">
                  <strong>Redemptions:</strong>{' '}
                  {result.redemptionCount}
                  {result.maxRedemptions ? ` of ${result.maxRedemptions}` : ''}
                  {result.lastRedeemedAt
                    ? ` · last on ${new Date(result.lastRedeemedAt).toLocaleDateString(undefined, {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric',
                      })}`
                    : ''}
                </p>
              )}
              {result.canRedeem && (
                <div className="login-input">
                  <button type="button" onClick={handleRedeem}>
                    Mark as Redeemed
                  </button>
                </div>
              )}
            </div>
          )}

          <div className="login-footer">
            <p>
              <button
                type="button"
                onClick={handleLogout}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  fontWeight: 'bold',
                  fontSize: '15px',
                  lineHeight: '14px',
                  color: '#E80000',
                  cursor: 'pointer',
                }}
              >
                Logout
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerVerifyPage;
